import WysiwygInput from './component';
import { WysiwygInputProps } from './types';

export default WysiwygInput;
export type { WysiwygInputProps };
